import { useCallback } from "react";
import { PdfPreview } from "@/components/PdfPreview";

export type ProductionAttachment = { taskId: string; name: string };
export type ProductionPdfProps = {
  attachment: ProductionAttachment | null;
  fetchAttachment: (taskId: string, name: string) => Promise<string | null>;
};

export function ProductionPdfPreview({
  attachment,
  fetchAttachment,
}: ProductionPdfProps) {
  const getDocumentUrl = useCallback(async () => {
    if (!attachment) throw new Error("Produksjonen inneholder ingen PDF.");
    const base64 = await fetchAttachment(attachment.taskId, attachment.name);
    if (!base64) throw new Error("Vedlegget mangler PDF-data.");
    return base64.startsWith("data:")
      ? base64
      : `data:application/pdf;base64,${base64}`;
  }, [attachment, fetchAttachment]);

  return attachment ? (
    <PdfPreview fileName={attachment.name} getDocumentUrl={getDocumentUrl} />
  ) : (
    <p role="alert" className="p-6 text-sm text-destructive">
      Produksjonen inneholder ingen PDF-fil som kan forhåndsvises.
    </p>
  );
}
